/* eslint-disable react/no-unknown-property */
import * as React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';


const PageSeo = ({ pageMeta, children }) => {
  let isHcp = false;
  if (typeof window !== 'undefined') {
    const storedValue = window.sessionStorage.getItem('isHCP');
    isHcp = storedValue === 'true';
  }
  return (
    <Helmet>
      <html lang='en-us' />
      <title>{pageMeta ? pageMeta.title : ''}</title>
      <meta name="keywords" content={pageMeta ? pageMeta.keywords : ''} />
      <meta name="description" content={pageMeta ? pageMeta.description : ''} />

       {!isHcp && (
        <script 
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js" 
          type="text/javascript" 
          data-domain-script={
            process.env.GATSBY_PRODUCTION_BUILD 
              ? 'dae2db3b-a7be-4550-8c3a-6a927aff312a' 
              : '01944014-f6da-70bd-8ff4-b0b34953e86c-test'
          } 
        />
      )}

      {!isHcp && (
        <script type="text/javascript">
          {`function OptanonWrapper() { } `}
        </script>
      )}

      <meta name="google-site-verification" content="GG0114BfKg2V84s7YPgfU9QF4vP-zjBNI9LoETrNRWg" />
    
      <script
        src="https://players.brightcove.net/1905768940001/meAxH3mZK_default/index.min.js">
      </script>
      <script>
      {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5WRH3JW');`
      }
      </script>
      {pageMeta && pageMeta.schemaJsonLD.map((script, i) => <script key={i} type="application/ld+json">{script}</script>)} 

      {/* To support multiple schemas. Make sure that `` exists with {} for any script. */}
      {children}

    </Helmet>
  );
};

export default PageSeo;
